import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

const FloatingNav: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // 一定のスクロール量（例: 300px）を超えたら表示
      const scrollThreshold = 300;
      setIsVisible(window.scrollY > scrollThreshold);
    };

    window.addEventListener('scroll', handleScroll);
    // 初期状態をチェック
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`${styles.floatingNav} ${isVisible ? styles['floatingNav--visible'] : ''}`}>
      <Link to="/2025/map" className={styles.navItem}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.3333 20L6.66667 17.6667L1.5 19.6667C1.12963 19.8148 0.787037 19.7733 0.472222 19.5422C0.157407 19.3111 0 19.0007 0 18.6111V3.05556C0 2.81481 0.0696296 2.60185 0.208889 2.41667C0.348148 2.23148 0.537778 2.09259 0.777778 2L6.66667 0L13.3333 2.33333L18.5 0.333333C18.8704 0.185185 19.213 0.227037 19.5278 0.458889C19.8426 0.690741 20 1.00074 20 1.38889V16.9444C20 17.1852 19.9307 17.3981 19.7922 17.5833C19.6537 17.7685 19.4637 17.9074 19.2222 18L13.3333 20ZM12.2222 17.2778V4.27778L7.77778 2.72222V15.7222L12.2222 17.2778Z"
            fill="currentColor"
          />
        </svg>
        <span className={styles.navLabel}>MAP</span>
      </Link>

      <Link to="/2025/timetable" className={styles.navItem}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 20H7V7.77778H13V20ZM15 20V7.77778H20V18.8889C20 19.1836 19.8946 19.4662 19.7071 19.6746C19.5196 19.8829 19.2652 20 19 20H15ZM5 20H1C0.734784 20 0.48043 19.8829 0.292893 19.6746C0.105357 19.4662 0 19.1836 0 18.8889V7.77778H5V20ZM20 5.55556H0V1.11111C0 0.816426 0.105357 0.533811 0.292893 0.325437C0.48043 0.117063 0.734784 0 1 0H19C19.2652 0 19.5196 0.117063 19.7071 0.325437C19.8946 0.533811 20 0.816426 20 1.11111V5.55556Z"
            fill="currentColor"
          />
        </svg>
        <span className={styles.navLabel}>タイムテーブル</span>
      </Link>

      <Link to="/2025/events" className={styles.navItem}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.83333 13.45L12.6944 9.975C12.9167 9.775 13.1852 9.675 13.5 9.675C13.8148 9.675 14.0833 9.775 14.3056 9.975C14.5278 10.175 14.6389 10.4167 14.6389 10.7C14.6389 10.9833 14.5278 11.225 14.3056 11.425L9.61111 15.65C9.38889 15.85 9.12963 15.95 8.83333 15.95C8.53704 15.95 8.27778 15.85 8.05556 15.65L5.69444 13.525C5.47222 13.325 5.36111 13.0833 5.36111 12.8C5.36111 12.5167 5.47222 12.275 5.69444 12.075C5.91667 11.875 6.18519 11.775 6.5 11.775C6.81481 11.775 7.08333 11.875 7.30555 12.075L8.83333 13.45ZM2.22222 20C1.61111 20 1.08815 19.8043 0.653333 19.413C0.218519 19.0217 0.000740741 18.5507 0 18V4C0 3.45 0.217778 2.97934 0.653333 2.588C1.08889 2.19667 1.61185 2.00067 2.22222 2H3.33333V1C3.33333 0.71667 3.44 0.479337 3.65333 0.288003C3.86667 0.0966702 4.13037 0.000670115 4.44444 3.44827e-06C4.75852 -0.000663218 5.02259 0.0953369 5.23667 0.288003C5.45074 0.48067 5.55704 0.718003 5.55556 1V2H14.4444V1C14.4444 0.71667 14.5511 0.479337 14.7644 0.288003C14.9778 0.0966702 15.2415 0.000670115 15.5556 3.44827e-06C15.8696 -0.000663218 16.1337 0.0953369 16.3478 0.288003C16.5619 0.48067 16.6681 0.718003 16.6667 1V2H17.7778C18.3889 2 18.9122 2.196 19.3478 2.588C19.7833 2.98 20.0007 3.45067 20 4V18C20 18.55 19.7826 19.021 19.3478 19.413C18.913 19.805 18.3896 20.0007 17.7778 20H2.22222ZM2.22222 18H17.7778V8H2.22222V18ZM2.22222 6H17.7778V4H2.22222V6Z"
            fill="currentColor"
          />
        </svg>
        <span className={styles.navLabel}>イベント</span>
      </Link>
    </nav>
  );
};

export default FloatingNav;
